import { RETRY_NUMBER_TIMES } from 'constants/Global';
import restClient from '../config/httpClient';

/**
 * Retry wrapper
 * @param {Function} requestFn - async function to call
 * @param {number} retries - number of attempts
 * @param {number} delay - initial delay in ms
 * @returns {Promise<any>}
 */
const fetchRetryExp = async (requestFn, retries = 5, delay = 200) => {
  try {
    return await requestFn();
  } catch {
    if (retries <= 1) {
      throw new Error('fetchRetry exhausted all attempts');
    }
    // eslint-disable-next-line no-promise-executor-return
    await new Promise((resolve) => setTimeout(resolve, delay));
    return fetchRetryExp(requestFn, retries - 1, delay * 2);
  }
};

/**
 * Request loop with retry
 * @param {Object} requestParams
 * @returns {Promise<any>}
 */
const requestLoopExp = async (requestParams) =>
  fetchRetryExp(async () => {
    const { data, status } = await restClient.request(requestParams);
    if (status === 200) {
      return data;
    }
    throw new Error(`Request failed with status ${status}`);
  }, RETRY_NUMBER_TIMES);

export default requestLoopExp;
